<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">SPD Records History</h1>
    </div>

    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> / <b>TBA</b> /
      <b>SPD Entry Log</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">SPD Records History</h4>

            <div class="row mb-3">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="dto.start_date"
                />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="dto.end_date"
                />
              </div>
            </div>

            <div class="text-right mb-2">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px"
                @click="filter"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px"
                @click="reset"
              >
                Reset
              </button>
            </div>

            <div class="d-flex justify-content-between mb-2 mt-4">
              <button class="btn btn-primary" @click="exportToExcel">
                Excel
              </button>
              <input
                type="text"
                class="form-control"
                placeholder="Search..."
                v-model="searchText"
                style="width: 300px"
              />
            </div>

            <div class="table-responsive">
              <table
                id="spd_history_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(spd, index) in filteredRecords" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>
                      {{ spd.sum_covered }}
                    </td>
                    <td>
                      {{ spd.amount_paid }}
                    </td>
                    <td>{{ spd.ncd }}</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>
                      {{ spd.purchased_at }}
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary btn-block"
                        :to="redirect(spd)"
                      >
                        View Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-controls text-center mt-3">
              <button
                class="btn btn-primary mr-2"
                :disabled="dto.page_no <= 1"
                @click="prevPage"
              >
                Previous
              </button>

              <span>Page {{ dto.page_no }} of {{ totalPages }}</span>

              <button
                class="btn btn-primary ml-2"
                :disabled="dto.page_no >= totalPages"
                @click="nextPage"
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpdHistories } from "@/services/SpdRecordService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from "xlsx";

export default {
  name: "tba_speed_records_history",
  components: { Loading },
  data() {
    const today = new Date();
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(today.getDate() - 14);

    return {
      spd_passed_lists: [],
      dto: {
        start_date: null,
        end_date: null,
        page_no: 1,
      },
      isLoading: false,
      fullPage: true,
      totalPages: 1,
      searchText: "",
    };
  },

  computed: {
    filteredRecords() {
      if (!this.searchText) return this.spd_passed_lists;
      const term = this.searchText.toLowerCase();
      return this.spd_passed_lists.filter((spd) =>
        Object.values(spd).some(
          (val) => val && val.toString().toLowerCase().includes(term)
        )
      );
    },
  },

  methods: {
    async loadSpdEntry(page = 1) {
      this.isLoading = true;
      this.dto.page_no = page;
      try {
        const response = await getSpdHistories(this.dto);
        this.spd_passed_lists = response.data.data;
        this.totalPages = response.data.total_pages || 1;
        this.dto.page_no = response.data.current_page;
      } catch (error) {
        swal(
          "Try Again",
          error.response.data.message || error.message,
          "error"
        );
      }
      this.isLoading = false;
    },

    // redirect(sysId, type) {
    //   return `/tba/spd_records/${sysId}/${type}`;
    // },
    redirect(spd) {
      return {
        name: "tba_speed_record", // route name
        params: { sysId: spd.sys_id, type: 1 }, // params
        query: { spdData: JSON.stringify(spd) }, // pass full object
      };
    },

    async filter() {
      if (!this.dto.start_date || !this.dto.end_date) {
        swal("Try Again", "Please fill in start and end date", "error");
        return;
      }
      await this.loadSpdEntry(1);
    },

    async reset() {
      this.dto.start_date = this.dto.end_date = null;
      this.dto.page_no = 1;
      await this.loadSpdEntry(1);
    },

    async nextPage() {
      if (this.dto.page_no < this.totalPages) {
        await this.loadSpdEntry(this.dto.page_no + 1);
      }
    },

    async prevPage() {
      if (this.dto.page_no > 1) {
        await this.loadSpdEntry(this.dto.page_no - 1);
      }
    },

    exportToExcel() {
      const ws = XLSX.utils.json_to_sheet(this.filteredRecords);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SPD History");
      XLSX.writeFile(wb, "spd_history.xlsx");
    },
  },
  async created() {
    await this.loadSpdEntry(1);
  },
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
